import { apiSlice } from "../apiSlice";

const profileApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProfile: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/profile/${id}`,
                    method: "GET",
                };
            },
            providesTags: ['profile'],
        }),
        getOperatorProfile: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/operator/${id}`,
                    method: "GET",
                };
            },
            providesTags: ['profile'],
        }),
        updateBranch: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/profile/update/${body.branchId}`,
                    method: "PATCH",
                    body: body.data
                };
            },
            invalidatesTags: ['profile', 'operatorList'],
        }),
        updateProfile: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/operator/update/${body.profileId}`,
                    method: "PATCH",
                    body: body.data
                };
            },
            invalidatesTags: ['profile', 'operatorList'],
        }),
        changePassword: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/operator/change-password/${body.profileId}`,
                    method: "POST",
                    body: body.data
                };
            },
            invalidatesTags: ['profile'],
        }),
        getDashboard: builder.query({
            query: () => {
                return {
                    url: `/api/admin/dashboard`,
                    method: "GET",
                };
            },
            providesTags: ['branchList', 'districtList', 'merchantList', 'profile', 'riderList', 'roadList', 'upazilaList']
        }),
        getDashboardFilterByBranch: builder.query({
            query: ({ branch_id, from_date, to_date }) => {
                return {
                    url: `/api/branch/dashboard/${branch_id}?start_date=${from_date}&end_date=${to_date}`,
                    method: "GET",
                };
            },
            providesTags: ['branchList', 'districtList', 'merchantList', 'profile', 'riderList', 'roadList', 'upazilaList']
        }),
        getDashboardFilterByMerchant: builder.query({
            query: ({ merchant_id, from_date, to_date }) => {
                return {
                    url: `/api/merchant/dashboard/${merchant_id}?start_date=${from_date}&end_date=${to_date}`,
                    method: "GET",
                };
            },
            providesTags: ['branchList', 'districtList', 'merchantList', 'profile', 'riderList', 'roadList', 'upazilaList']
        }),
    }),
    overrideExisting: true,
});

export const { useGetProfileQuery, useUpdateProfileMutation, useChangePasswordMutation, useGetOperatorProfileQuery, useGetDashboardQuery, useUpdateBranchMutation, useGetDashboardFilterByBranchQuery, useGetDashboardFilterByMerchantQuery } = profileApiSlice;
